import { render, staticRenderFns } from "./ACertificadoWebinar.vue?vue&type=template&id=0d3208a5"
import script from "./ACertificadoWebinar.vue?vue&type=script&lang=js"
export * from "./ACertificadoWebinar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports